import { ICompleteTodo, IEditTodo,  ICreateTodo, IHideTodo } from '@app-types/websocket/todo.types';

import { createAction } from 'redux-act';

export const createTodo = createAction<ICreateTodo>('Create Todo');
export const editTodo = createAction<IEditTodo>('Edit Todo');
export const deleteTodo = createAction<number>('Delete Todo');
export const completeTodo = createAction<ICompleteTodo>('Complete Todo');
export const hideTodo = createAction<IHideTodo>('Hide Todo');
export const seenTodo = createAction<IHideTodo>('Seen Todo');
export const completeHandover = createAction<number>('Complete handover for schedule');




// WEBPACK FOOTER //
// ./src/services/todos/todo.action.ts